import type { ProductLogoSmallProps } from '../types';

/**
 * 小サイズのUserAccountsロゴアイコン（User Accounts & Auth）
 */
export function ProductLogoSmallUserAccounts({
  size = 20,
  color = '#646467',
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 480 480"
      fill="none"
      {...props}
    >
      <g transform="translate(36 36)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M402.999 257.5V316.677C402.999 340.691 395.85 362.533 381.553 382.202C367.255 401.871 349.126 414.47 327.166 420C305.206 414.471 287.077 401.871 272.779 382.202C258.482 362.533 251.332 340.691 251.332 316.677L251.333 257.5L327.166 225L402.999 257.5ZM362.967 288.787C360.146 285.967 355.573 285.967 352.753 288.787L314.965 326.576L302.454 314.065C299.634 311.245 295.061 311.245 292.24 314.065L287.134 319.172C284.313 321.992 284.313 326.565 287.134 329.386L309.858 352.11C312.679 354.931 317.252 354.931 320.072 352.11L368.074 304.108C370.895 301.288 370.894 296.715 368.074 293.895L362.967 288.787Z"
          fill={color}
        />
        <path
          d="M204 0C316.666 0 408 91.3339 408 204C408 213.733 407.317 223.306 405.999 232.675L371.433 217.86C371.806 213.289 372 208.667 372 204C372 111.216 296.784 36 204 36C111.216 36 36 111.216 36 204C36 246.856 52.0472 285.963 78.46 315.643C91.131 285.314 121.076 264 156 264H227.332V316.677C227.332 345.829 236.127 372.599 253.365 396.313C254.54 397.93 255.741 399.51 256.966 401.055C240.075 405.583 222.32 408 204 408C91.3339 408 0 316.666 0 204C0 91.3339 91.3339 0 204 0Z"
          fill={color}
        />
        <path
          d="M273.451 383.119C275.929 386.462 278.521 389.595 281.226 392.521C281.305 392.606 281.385 392.691 281.465 392.776C280.892 392.161 280.323 391.538 279.761 390.904C279.277 390.359 278.796 389.806 278.319 389.247C276.651 387.289 275.028 385.246 273.451 383.119Z"
          fill={color}
        />
        <path
          d="M204 96C243.765 96 276 128.235 276 168C276 207.765 243.765 240 204 240C164.235 240 132 207.765 132 168C132 128.235 164.235 96 204 96Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
